export type SafeHrefKind = 'internal' | 'https';

export function classifySafeHref(href: string | null | undefined): SafeHrefKind | null {
  if (typeof href !== 'string') {
    return null;
  }
  const value = href.trim();
  if (value === '') {
    return null;
  }
  if (value.startsWith('/') && !value.startsWith('//') && !/^[a-z][a-z0-9+.-]*:/i.test(value)) {
    return 'internal';
  }
  if (/^https:\/\//i.test(value)) {
    return 'https';
  }
  return null;
}

export function isHttpUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}

export function isInternalPath(url: string): boolean {
  return classifySafeHref(url) === 'internal';
}
